(function () {

  function initPogoSizeFinder() {

    var openBtn = document.getElementById('pogo-fit-open');

    if (!openBtn) {
      return false;
    }

    if (openBtn.dataset.pogoReady === '1') {
      return true;
    }

    openBtn.dataset.pogoReady = '1';


    /* =========================
       ELEMENTI
    ========================= */

    var overlay = document.getElementById('pogo-fit-overlay');
    var closeBtn = document.getElementById('pogo-fit-close');

    var manBtn = document.getElementById('pogo-man');
    var womanBtn = document.getElementById('pogo-woman');

    var heightInput = document.getElementById('pogo-height');
    var weightInput = document.getElementById('pogo-weight');

    var calculateBtn = document.getElementById('pogo-calculate');

    var form = document.getElementById('pogo-fit-form');
    var result = document.getElementById('pogo-result');

    var resultSize = document.getElementById('pogo-result-size');
    var resultCopy = document.getElementById('pogo-result-copy');

    var useSizeBtn = document.getElementById('pogo-use-size');
    var retryBtn = document.getElementById('pogo-retry');

    var error = document.getElementById('pogo-error');


    var gender = 'man';
    var recommendedSize = '';


    /* =========================
       APRI / CHIUDI POPUP
    ========================= */

    function openPopup() {

      overlay.style.display = 'flex';

      document.body.style.overflow = 'hidden';

    }


    function closePopup() {

      overlay.style.display = 'none';

      document.body.style.overflow = '';

    }


    openBtn.addEventListener('click', function (e) {

      e.preventDefault();

      openPopup();

    });


    closeBtn.addEventListener('click', function () {

      closePopup();

    });


    overlay.addEventListener('click', function (e) {

      if (e.target === overlay) {

        closePopup();

      }

    });


    document.addEventListener('keydown', function (e) {

      if (e.key === 'Escape') {

        closePopup();

      }

    });


    /* =========================
       UOMO / DONNA
    ========================= */

    manBtn.addEventListener('click', function () {

      gender = 'man';

      manBtn.style.background = '#111';
      manBtn.style.color = '#fff';

      womanBtn.style.background = '#fff';
      womanBtn.style.color = '#111';

    });


    womanBtn.addEventListener('click', function () {

      gender = 'woman';

      womanBtn.style.background = '#111';
      womanBtn.style.color = '#fff';

      manBtn.style.background = '#fff';
      manBtn.style.color = '#111';

    });


    /* =========================
       TAGLIE UOMO
    ========================= */

    function maleSize(height, weight) {

      var size;


      /* ALTEZZA PRINCIPALE */

      if (height <= 173) {

        size = 'S';

      }

      else if (height <= 178) {

        size = 'M';

      }

      else if (height <= 185) {

        size = 'L';

      }

      else {

        size = 'XL';

      }


      /* PESO CORREGGE SOLO CASI ESTREMI */

      if (
        height <= 173 &&
        weight >= 78
      ) {

        size = 'M';

      }


      if (
        height >= 174 &&
        height <= 178 &&
        weight >= 85
      ) {

        size = 'L';

      }


      if (
        height >= 179 &&
        height <= 185 &&
        weight >= 95
      ) {

        size = 'XL';

      }


      return size;

    }


    /* =========================
       TAGLIE DONNA

       FINO A 158 CM = XS
       SOPRA 158 CM = S

       MAI M / L
    ========================= */

    function femaleSize(height, weight) {

      if (height <= 158) {

        return 'XS';

      }

      return 'S';

    }


    /* =========================
       CALCOLA TAGLIA
    ========================= */

    calculateBtn.addEventListener('click', function () {

      var height = parseInt(
        heightInput.value,
        10
      );

      var weight = parseInt(
        weightInput.value,
        10
      );


      error.style.display = 'none';


      /* CONTROLLA CAMPI */

      if (
        isNaN(height) ||
        isNaN(weight)
      ) {

        error.textContent =
          'Inserisci altezza e peso.';

        error.style.display = 'block';

        return;

      }


      /* CONTROLLO ALTEZZA */

      if (
        height < 140 ||
        height > 210
      ) {

        error.textContent =
          'Controlla l’altezza inserita.';

        error.style.display = 'block';

        return;

      }


      /* CONTROLLO PESO */

      if (
        weight < 35 ||
        weight > 180
      ) {

        error.textContent =
          'Controlla il peso inserito.';

        error.style.display = 'block';

        return;

      }


      /* CALCOLO */

      if (gender === 'man') {

        recommendedSize =
          maleSize(height, weight);

      }

      else {

        recommendedSize =
          femaleSize(height, weight);

      }


      /* MOSTRA RISULTATO */

      resultSize.textContent =
        recommendedSize;


      resultCopy.textContent =
        'In base ai dati che hai inserito, questa è la taglia che ti consigliamo.';


      useSizeBtn.textContent =
        'PRENDO LA ' + recommendedSize;


      form.style.display = 'none';

      result.style.display = 'block';

    });


    /* =========================
       MODIFICA DATI
    ========================= */

    retryBtn.addEventListener('click', function () {

      result.style.display = 'none';

      form.style.display = 'block';

    });


    /* =========================
       SELEZIONA AUTOMATICAMENTE
       LA TAGLIA DEL PRODOTTO
    ========================= */

    useSizeBtn.addEventListener('click', function () {

      if (!recommendedSize) {

        return;

      }


      var wanted =
        recommendedSize
          .toLowerCase()
          .trim();


      /* -------------------------
         CERCA RADIO BUTTON
      ------------------------- */

      var radios =
        document.querySelectorAll(
          'input[type="radio"]'
        );


      for (
        var i = 0;
        i < radios.length;
        i++
      ) {

        var radioValue =
          (radios[i].value || '')
            .toLowerCase()
            .trim();


        if (radioValue === wanted) {

          radios[i].click();


          radios[i].dispatchEvent(

            new Event(
              'change',
              {
                bubbles: true
              }
            )

          );


          closePopup();

          return;

        }

      }


      /* -------------------------
         CERCA SELECT
      ------------------------- */

      var selects =
        document.querySelectorAll(
          'select'
        );


      for (
        var s = 0;
        s < selects.length;
        s++
      ) {


        for (
          var o = 0;
          o < selects[s].options.length;
          o++
        ) {


          var optionText =
            (
              selects[s]
                .options[o]
                .textContent || ''
            )
              .toLowerCase()
              .trim();


          var optionValue =
            (
              selects[s]
                .options[o]
                .value || ''
            )
              .toLowerCase()
              .trim();


          if (
            optionText === wanted ||
            optionValue === wanted
          ) {


            selects[s].selectedIndex = o;


            selects[s].dispatchEvent(

              new Event(
                'change',
                {
                  bubbles: true
                }
              )

            );


            closePopup();

            return;

          }

        }

      }


      /* SE IL TEMA NON PERMETTE
         LA SELEZIONE AUTOMATICA */

      useSizeBtn.textContent =
        'SELEZIONA LA ' +
        recommendedSize +
        ' QUI SOPRA';

    });


    return true;

  }


  /* =========================
     AVVIO
  ========================= */


  /* PROVA SUBITO */

  initPogoSizeFinder();


  /* QUANDO LA PAGINA È CARICA */

  document.addEventListener(
    'DOMContentLoaded',
    initPogoSizeFinder
  );


  /* EDITOR SHOPIFY */

  document.addEventListener(
    'shopify:section:load',
    initPogoSizeFinder
  );


  /* FALLBACK */

  setTimeout(
    initPogoSizeFinder,
    500
  );


  setTimeout(
    initPogoSizeFinder,
    1500
  );


  setTimeout(
    initPogoSizeFinder,
    3000
  );


})();